import { IEntity } from "./Entity";

export interface ICustomerApp  extends IEntity {
    ID: number;
    CustomerID?: number;
    AppID?: number;
}

export class CustomerApp implements ICustomerApp {
    public ID: number = 0;
    public Title: string = null;
    public CustomerID?: number = null;
    public AppID?: number = null;
}